import { Drawer } from './Drawer';
import {
  FilterFeld, aktiveFilterZahl, leererWert,
  type FilterDefinition, type FilterWerte,
} from './FilterBar';
import './muster.css';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * FILTERSCHUBFACH (Auftrag 17.09.2026, Abschnitt 11 und 16)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 *   „Bei umfangreichen Filtern: rechte Filter-Sidebar oder Drawer."
 *
 * Alle Filter untereinander, jeder über die ganze Breite - Abkürzungen wie
 * in der Leiste sind hier fehl am Platz, man ist ja gerade deshalb hier.
 *
 * Die Filter wirken UNMITTELBAR (jede Änderung meldet sich sofort nach
 * oben). Ein `[Anwenden]`-Knopf wäre ein zweiter Zustand, den man vergessen
 * kann - und die Liste dahinter bleibt sichtbar, weil `Drawer` die Seite
 * nicht sperrt.
 *
 * Alles Fachliche steckt in `FilterBar` (Begriffe, Adresszeile, das
 * einzelne Feld). Diese Datei ist nur die andere Darstellungsform.
 */

export interface FilterDrawerProps {
  offen: boolean;
  filter: FilterDefinition[];
  werte: FilterWerte;
  beiAenderung: (werte: FilterWerte) => void;
  beiSchliessen: () => void;
  /** Eigenes Zurücksetzen; ohne Angabe setzt das Schubfach selbst zurück. */
  beiZuruecksetzen?: () => void;
  titel?: string;
  /** Wieviele Treffer die aktuelle Einstellung ergibt - wenn bekannt. */
  trefferText?: string;
}

export function FilterDrawer({
  offen, filter, werte, beiAenderung, beiSchliessen, beiZuruecksetzen,
  titel = 'Filter', trefferText,
}: FilterDrawerProps) {
  const gesetzt = aktiveFilterZahl(werte);

  const zuruecksetzen = () => {
    if (beiZuruecksetzen) { beiZuruecksetzen(); return; }
    const leer: FilterWerte = {};
    for (const f of filter) leer[f.schluessel] = leererWert(f.art);
    beiAenderung(leer);
  };

  return (
    <Drawer
      offen={offen}
      titel={titel}
      beschreibung={gesetzt === 0
        ? 'Kein Filter gesetzt - die Liste zeigt alles.'
        : `${gesetzt} ${gesetzt === 1 ? 'Filter' : 'Filter'} gesetzt${
          trefferText ? `; ${trefferText}` : ''}`}
      beiSchliessen={beiSchliessen}
      className="m-filterschubfach"
      fuss={(
        <>
          <button
            type="button"
            className="m-knopf"
            onClick={zuruecksetzen}
            disabled={gesetzt === 0}
          >
            Alle zurücksetzen
          </button>
          <button type="button" className="m-knopf m-knopf-haupt" onClick={beiSchliessen}>
            Fertig
          </button>
        </>
      )}
    >
      <div className="m-feldgitter m-feldgitter-1">
        {filter.map((f) => (
          <FilterFeld
            key={f.schluessel}
            definition={f}
            werte={werte}
            beiAenderung={beiAenderung}
            breite="voll"
          />
        ))}
      </div>
    </Drawer>
  );
}
